import { useEffect } from 'react';
import { connect } from 'react-redux';
import apex from 'apex-web/lib/apex';
import { withRouter } from 'react-router';
import {
  login,
  AUTH_2FA_REQUIRED,
  ENABLE_2FA_REQUIRED,
  AUTH_ERROR
} from 'apex-web/lib/redux/actions/authActions';
import path from 'apex-web/lib/helpers/path';
import FullPageSpinner from 'apex-web/lib/components/common/FullPageSpinner/FullPageSpinner';
import { jwtDecode } from 'jwt-decode';
import { useQuery } from '../hook';

const SilentLogin = ({ handleLogin, isConnected }) => {
  const query = useQuery();
  const token = query.get('token');

  useEffect(
    () => {
      if (isConnected) {
        if (token) {
          handleLogin(
            {
              JWTToken: token
            },
            isConnected
          );
        } else {
          window.location.replace(process.env.REACT_APP_NOMIX_AUTH_URL);
        }
      }
    },
    [isConnected, token]
  );
  return (
    <div>
      <FullPageSpinner pastDelay isVisible />
    </div>
  );
};

const mapStateToProps = state => ({
  isConnected: state.wsConnection.isConnected
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  handleLogin: async payload => {
    const decodedToken = jwtDecode(payload.JWTToken);
    await apex.connection.RPCPromise('SSOEnsureUser', {
      data: { email: decodedToken.email },
      sig: { algorithm: 'RSA256', value: '' },
      auth: {
        Authorization: payload.JWTToken
      }
    });

    dispatch(login(payload)).then(action => {
      if (action.type === AUTH_ERROR) {
        ownProps.history.push(path('/login'));
      } else {
        localStorage.setItem('JWTToken', payload.JWTToken);
      }
      if (action.type === ENABLE_2FA_REQUIRED) {
        ownProps.history.push(path('/enabletwofactorauth'));
      } else if (action.type === AUTH_2FA_REQUIRED) {
        ownProps.history.push(path('/twofactorauth'));
      }
    });
  }
});

const SilentLoginContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(SilentLogin);

export default withRouter(SilentLoginContainer);
